export const Percent = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			d="M6.15451 20.8558C5.68756 20.5809 5.5481 20.0052 5.84302 19.5699L16.775 3.43453C17.0699 2.99924 17.6876 2.86924 18.1545 3.14415C18.6215 3.41907 18.7609 3.99481 18.466 4.4301L7.53399 20.5655C7.23908 21.0008 6.62146 21.1308 6.15451 20.8558Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 12.0317C9.20914 12.0317 11 10.3623 11 8.30291C11 6.24356 9.20914 4.57413 7 4.57413C4.79086 4.57413 3 6.24356 3 8.30291C3 10.3623 4.79086 12.0317 7 12.0317ZM7 10.1673C8.10457 10.1673 9 9.33258 9 8.30291C9 7.27324 8.10457 6.43852 7 6.43852C5.89543 6.43852 5 7.27324 5 8.30291C5 9.33258 5.89543 10.1673 7 10.1673Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21 16.6927C21 18.752 19.2091 20.4214 17 20.4214C14.7909 20.4214 13 18.752 13 16.6927C13 14.6333 14.7909 12.9639 17 12.9639C19.2091 12.9639 21 14.6333 21 16.6927ZM19 16.6927C19 17.7223 18.1046 18.557 17 18.557C15.8954 18.557 15 17.7223 15 16.6927C15 15.663 15.8954 14.8283 17 14.8283C18.1046 14.8283 19 15.663 19 16.6927Z"
			fill="currentColor"
		/>
	</svg>
);
